import { mapGetters, mapMutations } from 'vuex';
import Forms from './../../utils/forms/forms';
import projectService from '../../services/project';
import projectTransformer from './../../transformers/project';

export default {
  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        description: {
          value: '',
          type: 'text',
        },
      }),
    };
  },

  computed: {
    ...mapGetters({
      allProjects: 'allProjects',
    }),
  },

  watch: {
    allProjects() {
      // console.log(this.allProjects);
    },
  },

  methods: {
    ...mapMutations({
      //
    }),

    /**
     * Saves the form, adding a product.
     */
    save() {
      this.form.loading = true;
      const project = projectTransformer.send(
        Object.assign({}, this.form.data())
      );
      projectService.store(project)
      .then(() => {
        this.form.loading = false;
        projectService.all();
      })
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
      return Promise.all([]);
    },

    /**
     * Updates a order product.
     */
    update(projectId) {
      this.form.loading = true;
      const project = projectTransformer.send(
        Object.assign({}, this.form.data())
      );
      projectService.update(projectId, project)
      .then(() => {
        this.form.loading = false;
        projectService.all();
      })
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
      return Promise.all([]);
    },

    /**
     * Delete the product from order.
     */
    destroy(projectId) {
      projectService.destroy(projectId)
      .then(() => {
        this.form.loading = false;
        projectService.all();
      })
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },

    /**
     * Fetch the component's required resources.
     */
    getResources() {
      Promise.all([
        projectService.all(),
      ]);
    },
  },

  mounted() {
    this.getResources();
  },

  components: {
    VFormTable: require('./../formTable/formTable.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/projectTable/projectTable.js